import i18n from "i18next";
import {call, put, takeLatest} from "redux-saga/effects";
import {cToast} from "helpers";
import spotService from "./api";
import {spotActions} from "./data";


function* fetchSpots({payload}){
    try{
        const data = yield call(spotService.getSpots,payload);
        yield put(spotActions.fetchSpotsSuccess(data));
    }catch (err) {
        yield put(spotActions.fetchSpotsFailure(err));
        if(err?.data?.detail){
            yield cToast({msg: i18n.t(err?.data?.detail),variant:'error'});
        }else{
            yield cToast({msg: i18n.t("Something went wrong"),variant:'error'});
        }
    }
}

function* fetchSpotById({payload}){
    try{
        const data = yield call(spotService.getSpotById,payload);
        yield put(spotActions.fetchSpotByIdSuccess(data));
    }catch (err) {
        yield put(spotActions.fetchSpotByIdFailure(err));
        if(err?.data?.detail){
            yield cToast({msg: i18n.t(err?.data?.detail),variant:'error'});
        }else{
            yield cToast({msg: i18n.t("Something went wrong"),variant:'error'});
        }
    }
}

function* fetchSpotReport({payload}){
    try{
        const data = yield call(spotService.getSpotReport,payload);
        yield put(spotActions.fetchSpotReportSuccess(data));
    }catch (err) {
        yield put(spotActions.fetchSpotReportFailure(err));
        if(err?.data?.detail){
            yield cToast({msg: i18n.t(err?.data?.detail),variant:'error'});
        }else{
            yield cToast({msg: i18n.t("Something went wrong"),variant:'error'});
        }
    }
}

export default function* roleSaga(){
    yield takeLatest(spotActions.fetchSpots.type, fetchSpots);
    yield takeLatest(spotActions.fetchSpotById.type, fetchSpotById);
    yield takeLatest(spotActions.fetchSpotReport.type, fetchSpotReport);
}